import { CSSProperties } from 'react'

import Lottie from 'react-lottie-player'

import circularAnimationBlack from 'assets/animations/loading_circular_black.json'
import circularAnimationWhite from 'assets/animations/loading_circular_white.json'
import boxAnimation from 'assets/animations/loading_component.json'
import MDBox from 'components/MDBox'

interface Props {
	width?: string | number
	height?: string | number
	borderRadius?: string | number
	type: 'box' | 'circular_white' | 'circular_black'
	speed?: number
	lottieStyle?: CSSProperties
	containerStyle?: CSSProperties
}

function LoadingComponent({
	width = '100%',
	height = 'inherit',
	borderRadius = '10px',
	type,
	lottieStyle,
	containerStyle,
	speed = 0.6,
}: Props): JSX.Element {
	return (
		<MDBox
			display={'flex'}
			pl={1}
			style={{
				width: width,
				height: height,
				...containerStyle,
			}}
		>
			<Lottie
				loop
				animationData={
					type === 'box'
						? boxAnimation
						: type === 'circular_black'
							? circularAnimationBlack
							: circularAnimationWhite
				}
				speed={speed}
				rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
				play
				style={{
					width: '100%',
					borderRadius: borderRadius,
					overflow: 'clip',
					...lottieStyle,
				}}
			/>
		</MDBox>
	)
}
export default LoadingComponent
